
export default {
  name: 'HomeVehicleTypes',
  data() {
    return {
      litCards: {},
      cardObserver: null,
    }
  },
  computed: {
    items() {
      const mapping = [
        {
          identifier: 'car',
          cutout: {
            src: '/vehicle-voiture.webp',
            pixels: [760, 442],
            width: 106,
            shift: -2,
          },
          labelKey: 'pages.index.vehicleTypes.car',
          domainId: 1,
          fallbackSlug: 'kits-et-ampoules-led-1',
        },
        {
          identifier: 'truck',
          cutout: {
            src: '/vehicle-camion.webp',
            pixels: [760, 703],
            width: 101,
            shift: 0,
          },
          labelKey: 'pages.index.vehicleTypes.truckCamper',
          domainId: 484,
          fallbackSlug: 'led-camion-caping-car-484',
        },
        {
          identifier: 'motorcycle',
          cutout: {
            src: '/vehicle-moto.webp',
            pixels: [760, 746],
            width: 96,
            shift: 0,
          },
          labelKey: 'pages.index.vehicleTypes.motorcycleQuad',
          domainId: 456,
          fallbackSlug: 'led-moto-quad-456',
        },
        {
          identifier: 'tractor',
          cutout: {
            src: '/vehicle-tracteur.webp',
            pixels: [760, 726],
            width: 98,
            shift: 0,
          },
          labelKey: 'pages.index.vehicleTypes.tractorConstruction',
          domainId: 4,
          fallbackSlug: 'tracteur-agricole-et-chantier-4',
        },
      ]
      const domains = this.$store.getters.domains
      return mapping.map(m => ({
        ...m,
        domainSlug:
          domains.find(d => d.id === m.domainId)?.slug || m.fallbackSlug,
        label: this.$t(m.labelKey),
      }))
    },
  },
  mounted() {
    this.$store.dispatch('setDomains')
    const touchScreen =
      window.matchMedia('(hover: none)').matches ||
      this.$device.isMobile ||
      window.innerWidth < 640
    if (!touchScreen || !('IntersectionObserver' in window)) return
    this.cardObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          this.$set(
            this.litCards,
            entry.target.dataset.identifier,
            entry.isIntersecting && entry.intersectionRatio >= 0.6
          )
        })
      },
      { threshold: [0, 0.6] }
    )
    this.$nextTick(() => {
      const cards = this.$refs.cards || []
      cards.forEach(card => this.cardObserver.observe(card.$el || card))
    })
  },
  beforeDestroy() {
    if (this.cardObserver) this.cardObserver.disconnect()
  },
}
